module.exports = __webpack_public_path__ + "static/media/T4-01.fef21e3c.svg";